import {
  VariableSelectorConfig,
  VariablesConfig,
} from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

import { OperatorEnum } from './types'

const operatorValues: OperatorEnum[] = [
  'eq',
  'neq',
  'one_of',
  'not_one_of',
  'contains',
  'not_contains',
  'gt',
  'gte',
  'lt',
  'lte',
]

const hasMultiSelectSupport = (config?: VariableSelectorConfig): boolean =>
  !!(config && 'multiSelect' in config && config.multiSelect)

export const getOperatorValuesForVariable = (
  variablesConfig: VariablesConfig,
  variableName?: string
): OperatorEnum[] => {
  if (!variableName) {
    return operatorValues.filter(
      (value) =>
        value !== 'one_of' &&
        value !== 'not_one_of' &&
        value !== 'contains' &&
        value !== 'not_contains'
    )
  }

  const config = variablesConfig[variableName]
  const hasMultiSelect = hasMultiSelectSupport(config)

  switch (config?.type) {
    case 'entity':
    case 'text':
      // Include 'one_of' and 'not_one_of' operators only if multi-select component is available
      if (hasMultiSelect) {
        return operatorValues.filter(
          (value) =>
            value === 'eq' || value === 'neq' || value === 'one_of' || value === 'not_one_of'
        )
      }
      return operatorValues.filter((value) => value === 'eq' || value === 'neq')
    case 'singleSelect':
      // Single select: is / is not / is one of / is not one of
      return operatorValues.filter(
        (value) => value === 'eq' || value === 'neq' || value === 'one_of' || value === 'not_one_of'
      )
    case 'multiSelect':
      // Multi select: contains / does not contain
      return operatorValues.filter((value) => value === 'contains' || value === 'not_contains')
    case 'number':
      // Numbers support all comparison operators except set operators
      return operatorValues.filter(
        (value) =>
          value !== 'one_of' &&
          value !== 'not_one_of' &&
          value !== 'contains' &&
          value !== 'not_contains'
      )
    case 'boolean':
      // Booleans only support equals/not equals
      return operatorValues.filter((value) => value === 'eq' || value === 'neq')
    case 'people_group_target':
      return ['in_people_group', 'not_in_people_group']
    default:
      // For unknown types, exclude set operators (one_of, not_one_of, contains, not_contains)
      return operatorValues.filter(
        (value) =>
          value !== 'one_of' &&
          value !== 'not_one_of' &&
          value !== 'contains' &&
          value !== 'not_contains'
      )
  }
}
